<template>
  <div
    id="SearchDetailModal"
    class="modal fade"
    tabindex="-1"
    role="dialog"
    aria-labelledby="modelSingle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl" role="document">
      <!--begin::Form-->
      <form class="kt-form">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">{{ this.$route.meta.breadcrumb }}</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <div class="kt-portlet__body">
              <div class="kt-section kt-section--first">
                <div class="row">
                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">BARCODE:</label>
                      <input
                        id="dbBarcodeOld"
                        type="text"
                        class="form-control"
                        v-model="dbBarcodeOld"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">รหัสทรัพย์สิน(เบียร์สด):</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="dbAssetOwner"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">ปี(สินค้า):</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="dbBarcodeYear"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">รหัสทรัพย์สิน(บัญชี):</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="dbAssetCode"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">BARCODE COOLING:</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="dbBarcodeCL"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">รหัสสินค้า:</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="dbMaterial"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">ชื่อสินค้า:</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="dbProduct"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">เจ้าของทรัพย์สิน:</label>
                      <input
                        type="text"
                        class="form-control"
                        readonly
                        v-model="dbOwner"
                      />
                    </div>
                  </div>

                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">Supplier:</label>
                      <input
                        type="text"
                        class="form-control"
                        readonly
                        v-model="dbSupplier"
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">วันที่เริ่มต้น:</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="dbStartDate"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">ระยะเวลาประกัน(วัน):</label>
                      <input
                        id="dbLongDate"
                        type="text"
                        class="form-control"
                        v-model="dbLongDate"
                        readonly
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">อายุของทรัพย์สิน(วัน):</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="dbExprie"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">สถานะทรัพย์สินเช่า:</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="dbLeasedAssets"
                        readonly
                      />
                    </div>
                  </div>

                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">รหัสอ้างอิง:</label>
                      <input
                        id="dbRefcode"
                        type="text"
                        class="form-control"
                        readonly
                        v-model="dbRefcode"
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">ประเภทสินค้า:</label>
                      <input
                        id="dbProductType"
                        type="text"
                        class="form-control"
                        readonly
                        v-model="dbProductType"
                      />
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group mb-3">
                      <label class="label mb-1">สินค้าพร้อมขาย:</label>
                      <input
                        id="dbBeerDetail"
                        type="text"
                        class="form-control"
                        readonly
                        v-model="dbBeerDetail"
                      />
                    </div>
                  </div>

                  <div class="col-xl-12 mt-3">
                    <!--begin: Datatable -->
                    <table
                      class="table-sm table-striped- table-bordered table-hover table-checkable"
                      id="detailTable"
                    >
                      <thead>
                        <tr>
                          <th>วันที่</th>
                          <th>หมายเลข Job</th>
                          <th>ที่ตั้ง</th>
                          <th>สถานะ</th>
                          <th>สแกนโดย</th>
                          <th>วันที่สแกน</th>
                          <th>ประเภทใบงาน</th>
                          <!-- <th>ไปยัง</th> -->
                        </tr>
                      </thead>
                    </table>
                    <!--end: Datatable -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >
              <i class="la la-close"></i> ปิดหน้าต่าง
            </button>
          </div>
        </div>
      </form>
      <!--end::Form-->
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import DatatableWarning from "../../../Shared/DatatableWarning";

export default {
  data: function() {
    return {
      dbBarcode: null,
      dbMaterial: null,
      dbAssetCode: null,
      dbAssetOwner: null,
      dbNfc: null,
      dbRefcode: null,
      dbProductType: null,
      dbProduct: null,
      dbStautsProduct: null,
      dbLocation: null,
      dbStartDate: null,
      dbLongDate: null,
      dbOwner: null,
      dbBarcodeOld: null,
      dbBarcodeCL: null,
      dbLeasedAssets: null,
      dbSupplier: null,
      dbExprie: null,
      dbBeerDetail: null,
      dbBarcodeYear:null,
    };
  },
  async mounted() {
    let self = this;
    let router = this.$router;

    KTApp.blockPage({
      opacity: 0.05,
      message: "กำลังดึงข้อมูล กรุณารอสักครู่...",
    });

    axios
      .get("/Api/Barcode/" + this.$route.params.id)
      .then(function(response) {
        if (response.status == 200) {
          // console.log(response);
          self.dbBarcode = response.data.barcodeNo;
          self.dbMaterial = response.data.materialCode;
          self.dbAssetCode = response.data.accountMaterialCode;
          self.dbAssetOwner = response.data.departmentMaterialCode;
          self.dbNfc = response.data.nfcCode;
          self.dbRefcode = response.data.refCode;
          self.dbProductType = response.data.productTypeName;
          self.dbProduct = response.data.materialDesc;
          self.dbBarcodeOld = response.data.barcodeIdOld;
          self.dbBarcodeCL = response.data.barcodeCooling;
          self.dbStartDate = response.data.warrantyStartDateS;
          self.dbLongDate = response.data.warrantyTime;
          self.dbLeasedAssets = response.data.isLeasedAssets == 1 ? 'ทรัพย์สินเช่า' : 'ทรัพย์สินบริษัท'
          self.dbOwner = response.data.assetOwnerName;
          self.dbSupplier = response.data.supplierName;
          self.dbExprie = response.data.exprie;
          self.dbBeerDetail = response.data.beerDetail;
          self.dbBarcodeYear = response.data.barcodeYear;
        } else {
          Swal.fire(
            "เกิดข้อผิดพลาด",
            "ไม่พบข้อมูลตัวแทนจำหน่ายที่คุณเลือก",
            "warning"
          );
          router.go(-1);
        }
      })
      .catch(function(error) {
        Swal.fire(
          "เกิดข้อผิดพลาด",
          "ระบบเกิดข้อผิดพลาด ไม่สามารถดึงข้อมูลตัวแทนจำหน่ายได้ในขณะนี้",
          "error"
        );
        router.go(-1);
      })
      .then(function() {
        // always executed
        KTApp.unblockPage();
      });

    $.fn.dataTable.ext.errMode = 'none';
    var table = $("#detailTable");
    //begin first table
    table.DataTable({
      responsive: true,
      processing: true,
      serverSide: true,
      searchDelay: 500,
      ajax: {
        url: "/Api/Barcode/SearchHistory",
        type: "post",
        dataType: "json",
        contentType: "application/json",
        beforeSend: function(request) {
          request.setRequestHeader(
            "Authorization",
            "Bearer " + self.$root.user.access_token
          );
        },
        data: function(d) {
          return JSON.stringify(
            $.extend(d, {
              BarcodeId: self.$route.params.id,
            })
          );
        },
      },

      // DOM Layout settings
      dom: `<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>
      <'row'<'col-sm-12'tr>>
    	<'row'<'col-sm-12 col-md-5'i><'col-sm-12 col-md-7 dataTables_pager'lp>>`,

      lengthMenu: [50, 100, 200, 500],

      pageLength: 100,

      language: {
        lengthMenu: "Display _MENU_",
      },

      // Order settings
      order: [[5, "desc"]],

      columns: [
        {
          data: "jobDate",
          className: "text-center",
          render: function(data, type, full, meta) {
            return full.jobDateText;
          },
        },
        { data: "jobNO", className: "text-center" },
        { data: "destination", className: "text-center" },
        { data: "barcodeStatueName", className: "text-center" },
        { data: "scanBy", className: "text-center" },
        {
          data: "scanDate",
          className: "text-center",
          render: function(data, type, full, meta) {
            return full.scanDateText;
          },
        },
        { data: "jobTypeName", className: "text-center" },
      ],
    })
    .on("error.dt", function ( e, settings, techNote, message ) {
      DatatableWarning.alert(techNote);
    });

    $("#SearchDetailModal")
      .on("hidden.bs.modal", function() {
        // Set go back
        router.go(-1);
        //self.$parent.reloadDataTable(false);
      })
      .modal("show");
  },
};
</script>



// WEBPACK FOOTER //
// App/Components/Master/Barcode/DetailBarcode.vue